import { render, staticRenderFns } from "./RoundedCorners.vue?vue&type=template&id=0f0c4e68&scoped=true"
var script = {}
import style0 from "./RoundedCorners.vue?vue&type=style&index=0&id=0f0c4e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c4e68",
  null
  
)

export default component.exports